import styled, { css } from 'styled-components';

import { PopUpWindow } from '@xing-com/pop-up-window';
import { InputBar } from '@xing-com/text-field';
import {
  cornerRadiusL,
  scale010,
  scale430,
  spaceL,
  spaceM,
  spaceS,
  spaceXL,
  spaceXXL,
  xdlColorBorder,
} from '@xing-com/tokens';
import { BodyCopy, Headline } from '@xing-com/typography';

const ImageCropperPopUpWindow = styled(PopUpWindow)`
  & > div {
    width: calc(100vw - (${spaceXXL} * 2));
    padding: ${spaceXXL};
  }
`;

const ImageCropperContainer = styled.div<{ $hasImage?: boolean }>`
  display: flex;
  flex-direction: column;
  width: calc(100vw - (${spaceXXL} * 4));
  ${({ $hasImage }) =>
    $hasImage
      ? css`
          height: 100vh;
          max-height: 630px;
        `
      : null};
`;

const ImageCropperImageContainer = styled.div`
  margin: ${spaceXL} 0;
  padding: ${spaceL} 0;
  position: relative;
  flex: 1 1 auto;

  [data-testid='container'] {
    border-radius: ${spaceS};
    background: rgba(0, 0, 0, 0.75);
  }
`;

const ImageCropperDropZone = styled.div`
  align-items: center;
  border: ${scale010} dashed ${xdlColorBorder};
  border-radius: ${cornerRadiusL};
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: ${spaceS} 0;
  min-height: ${scale430};
  padding: ${spaceXL};

  img {
    margin-bottom: ${spaceXL};
  }
`;

const ImageCropperDropZoneHeadline = styled(Headline)`
  margin-bottom: ${spaceM};
  margin-top: ${spaceL};
`;

const ImageCropperDropZoneCopy = styled(BodyCopy)`
  margin-bottom: ${spaceXL};
`;

const ImageCropperCaptionInput = styled(InputBar)`
  margin-bottom: ${spaceXL};
`;

const ImageCropperButtonsContainer = styled.div`
  align-items: center;
  display: flex;
  gap: ${spaceM};
  justify-content: flex-end;
`;

export const Styled = {
  ImageCropperPopUpWindow,
  ImageCropperContainer,
  ImageCropperImageContainer,
  ImageCropperDropZone,
  ImageCropperDropZoneHeadline,
  ImageCropperDropZoneCopy,
  ImageCropperCaptionInput,
  ImageCropperButtonsContainer,
};
